var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCtaBgMob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 397,
    viewBox: "0 0 390 397",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M79 393.4C79 395.388 77.3882 397 75.4 397L58.6 397C56.6118 397 55 395.388 55 393.4L55 367.447C55 366.492 54.6207 365.576 53.9456 364.901L53.499 364.454C52.8239 363.779 51.9082 363.4 50.9534 363.4L35.6367 363.4C34.682 363.4 33.7663 363.779 33.0912 364.454L32.0544 365.491C31.3793 366.166 31 367.082 31 368.037L31 393.4C31 395.388 29.3882 397 27.4 397L10.6 397C8.61177 397 6.99999 395.388 6.99999 393.4L7 367C7 365.012 8.61178 363.4 10.6 363.4L27.6787 363.4C28.5595 363.4 29.4043 363.05 30.0272 362.427C30.6501 361.804 31 360.96 31 360.079L31 328.6C31 326.612 32.6118 325 34.6 325L51.4 325C53.3882 325 55 326.612 55 328.6L55 359.373C55 360.328 55.3793 361.243 56.0544 361.919L56.4814 362.346C57.1565 363.021 58.0722 363.4 59.027 363.4L75.4 363.4C77.3882 363.4 79 365.012 79 367L79 393.4Z",
    fill: "url(#paint0_linear_2_102)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M112.949 242.95C113.558 242.342 114.382 242 115.243 242H140.488C142.428 242 144 240.428 144 238.488V213.512C144 211.572 142.428 210 140.488 210H115.513C113.573 210 112 211.572 112 213.512V238.201C112 239.133 111.63 240.026 110.972 240.685L110.685 240.971C110.027 241.63 109.133 242 108.202 242H83.5122C81.5724 242 80 243.572 80 245.512V270.488C80 272.428 81.5724 274 83.5122 274H108.487C110.427 274 112 272.428 112 270.488V245.243C112 244.383 112.341 243.558 112.949 242.95Z",
    fill: "url(#paint1_linear_2_102)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.341 198.932C317.763 199.354 318 199.926 318 200.523L318 267.75C318 268.993 319.007 270 320.25 270L339.75 270C340.992 270 342 268.993 342 267.75L342 200.69C342 200.093 342.237 199.521 342.659 199.099L343.098 198.659C343.52 198.237 344.093 198 344.689 198L363.478 198C364.074 198 364.647 198.237 365.069 198.659L365.341 198.931C365.763 199.353 366 199.926 366 200.522L366 219.75C366 220.992 367.007 222 368.25 222L387.75 222C388.993 222 390 220.992 390 219.75L390 200.25C390 199.007 388.993 198 387.75 198L368.524 198C367.927 198 367.355 197.763 366.933 197.341L366.659 197.067C366.237 196.645 366 196.073 366 195.476L366 176.25C366 175.007 364.993 174 363.75 174L344.524 174C343.927 174 343.355 173.763 342.933 173.341L342.659 173.067C342.237 172.645 342 172.073 342 171.476L342 152.25C342 151.007 340.993 150 339.75 150L320.25 150C319.008 150 318 151.007 318 152.25L318 171.643C318 172.24 317.763 172.812 317.341 173.234L317.234 173.341C316.812 173.763 316.24 174 315.643 174L296.25 174C295.007 174 294 175.008 294 176.25L294 195.644C294 196.24 293.763 196.813 293.341 197.235L293.235 197.341C292.813 197.763 292.24 198 291.644 198L272.251 198C271.008 198 270.001 199.007 270.001 200.25L270.001 219.75C270.001 220.992 271.008 222 272.251 222L291.75 222C292.993 222 294 220.992 294 219.75L294 200.689C294 200.092 294.237 199.52 294.659 199.098L295.098 198.659C295.52 198.237 296.092 198 296.689 198L315.477 198C316.074 198 316.646 198.237 317.068 198.659L317.341 198.932ZM318.932 197.341C319.354 197.763 319.927 198 320.523 198L339.643 198C340.24 198 340.812 197.763 341.234 197.341L341.341 197.234C341.763 196.812 342 196.24 342 195.643L342 176.522C342 175.926 341.763 175.353 341.341 174.931L341.069 174.659C340.647 174.237 340.074 174 339.478 174L320.69 174C320.093 174 319.521 174.237 319.099 174.659L318.659 175.099C318.237 175.521 318 176.093 318 176.69L318 195.477C318 196.074 318.237 196.646 318.659 197.068L318.932 197.341Z",
    fill: "url(#paint2_linear_2_102)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2444 74.8095C54.7932 75.3583 55.5377 75.6667 56.3139 75.6667H77.0725C78.689 75.6667 79.9993 76.9771 79.9993 78.5935V99.4065C79.9993 101.023 78.689 102.333 77.0725 102.333L56.0362 102.333C55.3195 102.333 54.6322 102.618 54.1254 103.125C53.6186 103.632 53.334 104.319 53.334 105.036V126.073C53.334 127.69 52.0236 129 50.4071 129H29.5941C27.9777 129 26.6673 127.69 26.6673 126.073V105.314C26.6673 104.538 26.3589 103.794 25.81 103.245L25.7559 103.191C25.2071 102.642 24.4626 102.333 23.6864 102.333H2.92683C1.31039 102.333 0 101.023 0 99.4065V78.5935C0 76.9771 1.31039 75.6667 2.92683 75.6667H23.5018C24.2781 75.6667 25.0225 75.3583 25.5714 74.8094L25.81 74.5708C26.3589 74.0219 26.6673 73.2775 26.6673 72.5012V51.9268C26.6673 50.3104 27.9777 49 29.5941 49H50.4071C52.0236 49 53.334 50.3104 53.334 51.9268V72.6867C53.334 73.463 53.6423 74.2074 54.1912 74.7563L54.2444 74.8095ZM52.4233 76.5239C51.8744 75.975 51.1299 75.6667 50.3537 75.6667H29.3691C28.6524 75.6667 27.965 75.9514 27.4582 76.4582C26.9514 76.965 26.6667 77.6524 26.6667 78.3691V99.3534C26.6667 100.13 26.975 100.874 27.5239 101.423L27.577 101.476C28.1259 102.025 28.8703 102.333 29.6466 102.333L50.169 102.333C50.9452 102.333 51.6897 102.025 52.2386 101.476L52.4754 101.239C53.0243 100.69 53.3327 99.9459 53.3327 99.1697V78.6456C53.3327 77.8694 53.0243 77.1249 52.4754 76.5761L52.4233 76.5239Z",
    fill: "url(#paint3_linear_2_102)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M319 1.22392e-06C322.314 1.36877e-06 325 2.68629 325 6V34C325 37.3137 322.314 40 319 40H291C287.686 40 285 37.3137 285 34L285 6C285 2.68629 287.686 -1.44847e-07 291 0L319 1.22392e-06Z",
    fill: "url(#paint4_linear_2_102)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_102",
    x1: 79,
    y1: 361,
    x2: 7,
    y2: 361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_102",
    x1: 112,
    y1: 210,
    x2: 112,
    y2: 274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_102",
    x1: 330,
    y1: 270,
    x2: 330,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_102",
    x1: 39.9997,
    y1: 49,
    x2: 39.9997,
    y2: 129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_102",
    x1: 305,
    y1: -0.00000332892,
    x2: 305,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtaBgMob);
export default __webpack_public_path__ + "static/media/ctaBgMob.b80a1e2001c741c79f5cb02e01428b14.svg";
export { ForwardRef as ReactComponent };